import {
  SET_MISSING_SONG_IMAGE_INFO,
  INITIALIZE_DOWNLOADED_SONGS,
  DOWNLOAD_SONGS_START,
  DOWNLOAD_SONGS_FAIL,
  DOWNLOAD_SONG_SUCCESS,
  DOWNLOAD_SONGS_SUCCESS,
  DOWNLOAD_SONG_REMOVE,
  SET_DOWNLOAD_ID,
  SET_DOWNLOAD_PROGRESS,
  SET_DOWNLOAD_NUMBER,
  SET_DOWNLOAD_PROMISE,
  TOGGLE_DOWNLOAD_IN_BACKGROUND,
  SET_MISSING_SONG_INFO,
  SET_MISSING_GENRE_IMAGE_INFO,
  DOWNLOAD_COMPANY_LOGO_SUCCESS,
  DOWNLOAD_COMPANY_LOGO_FAIL,
} from 'store/actions/actionTypes'

import { omit, uniq, uniqBy } from 'lodash'

const initialState = {
  downloadedSongs: [],
  downloadedFilesIds: [],
  downloadedRawSongsInfo: [],
  downloadedImages: [],
  downloadedGenreImages: [],
  isDownloading: false,
  downloadId: null,
  downloadProgress: 0,
  downloadNumber: 0,
  downloadNumberTotal: 0,
  downloadInBackground: false,
  error: null,
  downloadPromise: null,
}

const downloadReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_SONGS_START: {
      return {
        ...state,
        isDownloading: true,
        downloadNumberTotal: action.payload,
        error: null,
      }
    }

    case SET_DOWNLOAD_PROMISE: {
      return { ...state, downloadPromise: action.payload }
    }
    case SET_DOWNLOAD_ID: {
      return { ...state, downloadId: action.payload }
    }
    case SET_DOWNLOAD_PROGRESS: {
      return { ...state, downloadProgress: action.payload }
    }
    case SET_DOWNLOAD_NUMBER: {
      return { ...state, downloadNumber: action.payload }
    }
    case DOWNLOAD_SONGS_FAIL: {
      return {
        ...state,
        downloadId: null,
        downloadProgress: 0,
        downloadNumber: 0,
        downloadNumberTotal: 0,
        isDownloading: false,
        downloadInBackground: false,
        error: action.payload,
        downloadPromise: null,
      }
    }

    case DOWNLOAD_SONG_SUCCESS: {
      const { songId, songInfoRaw } = action.payload
      const imgExt = songInfoRaw.imageUrl.match(/[^.]+$/)[0]

      return {
        ...state,
        downloadedSongs: uniq([...state.downloadedSongs, songId]),
        downloadedFilesIds: uniq([...state.downloadedFilesIds, songId]),
        downloadedRawSongsInfo: uniqBy(
          [songInfoRaw, ...state.downloadedRawSongsInfo],
          'id'
        ),
        downloadedImages: uniqBy(
          [{ id: songId, ext: imgExt }, ...state.downloadedImages],
          'id'
        ),
      }
    }

    case DOWNLOAD_SONGS_SUCCESS: {
      return {
        ...state,
        downloadId: null,
        downloadProgress: 0,
        downloadNumber: 0,
        downloadNumberTotal: 0,
        isDownloading: false,
        downloadInBackground: false,
        downloadPromise: null,
        error: null,
      }
    }

    case DOWNLOAD_SONG_REMOVE: {
      return {
        ...state,
        downloadedSongs: state.downloadedSongs.filter((id) => id !== action.payload),
        downloadedFilesIds: state.downloadedFilesIds.filter(
          (id) => id !== action.payload
        ),
        downloadedRawSongsInfo: state.downloadedRawSongsInfo.filter(
          ({ id }) => id !== action.payload
        ),
        downloadedImages: state.downloadedImages.filter(
          ({ id }) => id !== action.payload
        ),
      }
    }

    case TOGGLE_DOWNLOAD_IN_BACKGROUND: {
      return {
        ...state,
        downloadInBackground: !state.downloadInBackground,
      }
    }

    case INITIALIZE_DOWNLOADED_SONGS: {
      const {
        downloadedSongs,
        downloadedFilesIds,
        downloadedRawSongsInfo,
        downloadedImages,
        downloadedGenreImages,
      } = action.payload

      return {
        ...state,
        downloadedSongs,
        downloadedFilesIds,
        downloadedRawSongsInfo,
        downloadedImages,
        downloadedGenreImages,
      }
    }

    case SET_MISSING_SONG_INFO: {
      const { addedDownloadedSongs, addedDownloadedRawSongInfo } = action.payload

      return {
        ...state,
        downloadedSongs: uniq([...state.downloadedSongs, ...addedDownloadedSongs]),
        downloadedRawSongsInfo: uniqBy(
          [...addedDownloadedRawSongInfo, ...state.downloadedRawSongsInfo],
          'id'
        ),
      }
    }

    case SET_MISSING_SONG_IMAGE_INFO: {
      const { idExt, songInfoRaw } = action.payload
      return {
        ...state,
        downloadedImages: uniqBy([idExt, ...state.downloadedImages], 'id'),
        downloadedRawSongsInfo: uniqBy(
          [songInfoRaw, ...state.downloadedRawSongsInfo],
          'id'
        ),
      }
    }

    case SET_MISSING_GENRE_IMAGE_INFO: {
      return {
        ...state,
        downloadedGenreImages: uniqBy(
          [action.payload, ...state.downloadedGenreImages],
          'id'
        ),
      }
    }

    case DOWNLOAD_COMPANY_LOGO_FAIL: {
      return {
        ...state,
        error: action.payload,
      }
    }

    case DOWNLOAD_COMPANY_LOGO_SUCCESS: {
      return {
        ...state,
      }
    }

    default:
      return { ...state }
  }
}

export default downloadReducer
